import { render, staticRenderFns } from "./Bl.vue?vue&type=template&id=01f9715c&"
import script from "./Bl.vue?vue&type=script&lang=js&"
export * from "./Bl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports